import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { SECONDARY_ANALYSES_LOADING, SECONDARY_ANALYSES_LOADED, SECONDARY_ANALYSES_ERROR } from 'redux/actionTypes/secondaryAnalyses';
var loadSecondaryAnalyses = function loadSecondaryAnalyses() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var secondaryAnalyses, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: SECONDARY_ANALYSES_LOADING
            });
            _context.prev = 1;
            _context.next = 4;
            return fetchAPI('/v2/secondaryAnalysis');
          case 4:
            secondaryAnalyses = _context.sent;
            dispatch({
              type: SECONDARY_ANALYSES_LOADED,
              payload: {
                secondaryAnalyses: secondaryAnalyses
              }
            });
            _context.next = 13;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_LOADING_PROJECT);
            dispatch({
              type: SECONDARY_ANALYSES_ERROR,
              payload: {
                error: errorMessage
              }
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadSecondaryAnalyses;